import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import WrenchSvg from '../../../assets/icons/app/wrench.svg?raw';

export const WrenchIcon = (props) => <CustomSVG svg={WrenchSvg} preserveColors appIconSmall {...props} />;
